import Rest from "../../../class/tool/Rest";
import Company from "./Company";
import StringTools from "../../../class/tool/StringTools";
import FormBuilder from "../../../class/tool/FormBuilder";

class CompanyController {
    _rest = new Rest();
    _callback = null;
    _baseURL = "companies";
	_errors = {
		"name": {
			"wrong": "Le nom doit être compris entre 2 et 30 caractères. Alphanumérique, caractères autorisés : - + ' # & , ."
		},
	};

	// perform

	setFormValues(object, setValues, formNew = false) {
		setValues(prev => ({
			...prev,
			name: object.name
		}));
	}
	setFormRows(setRows) {
		let rows = [
			{
				label: "Nom",
				attribute: "name",
				inputType: "text",
				returnType: "string",
				classnameWrapper: null,
				classnameLabel: null,
				classnameInput: "",
				placeholder: "Nom du groupe",
				autoComplete: "off",
				needed: true,
				checkData: null
			}
		];

		setRows(rows);
	}
	returnPutDatas(datas) {
		let datasToPost = {};
		let needed = ["name"];
		let optionals = [];

		for (let i in needed) {
			datasToPost[needed[i]] = datas[needed[i]];
		}

		for (let i in optionals) {
			if (datas[optionals[i]] === undefined || datas[optionals[i]] === null) continue;

			switch (typeof datas[optionals[i]]) {
				case "string":
					if (datas[optionals[i]].length === 0) continue;
					break;
				default: break;
			}

			datasToPost[optionals[i]] = datas[optionals[i]];
		}

		return datasToPost;
	}
	returnUpdatesFromCompare(object, datas, compare = true) {
		return FormBuilder.returnUpdates(object, datas, compare)
	}

	// control values

	hasValidMinimumDatas(values, type, subType = null) {
		let datas;
		let resultData;

		switch (type) {
			case "createCompanyGroup":
				datas = this.returnPutDatas(values);

				for (let key in datas) {
					resultData = this.checkDataToPut(key, datas[key]);

					if (!resultData.result)
						return false;
				}

				return true;
			default:
				return false;
		}
	}
	okToSend(datas, setEvent) {
		return true;
	}
	checkDataToPut(attribute, value) {
		switch (attribute) {
			case "name": return this.controlName(value);
			default:
				console.log("Unknown attribute", attribute);

				return {
					result: false,
					error: "Unknown attribute"
				};
		}
	}
	controlName(value) {
		if (value === undefined || value === null || value.length === 0) {
			return {
				result: false,
				error: this._errors["name"]["empty"]
			};
		}

		let regex = /^[a-zA-Z0-9\-+'.,#&\s]{2,30}$/i;

		if (!regex.test(StringTools.removeAccents(value))) {
			return {
				result: false,
				error: this._errors["name"]["wrong"]
			};
		}

		return {
			result: true,
			error: null
		};
	}

    index(input= "", tree = false, limit = null) {
        let params = ""

        if (input.length > 0)
            params += "?input=" + input

        if (tree) {
            params += (params.length === 0 ? "?" : "&")
            params += "tree=true"
        }

        if (limit !== null) {
            params += (params.length === 0 ? "?" : "&")
            params += "limit=" + limit
        }

        this._rest._contentType = 'application/json'
        this._rest.sendQuery(
            'GET',
            '/' + this._baseURL + params,
            {},
            this.handleIndex)
    }
    handleIndex = (response, error, status) => {
        let listObjects = []
        let pagination = null
        let data

        if (response.data !== undefined && response.data.data !== undefined) {
            if(response.data.total !== undefined) {
                pagination = {
                    total: response.data.total,
                    from: response.data.from != null ? response.data.from : 0,
                    to: response.data.to != null ? response.data.to : 0,
                    per_page: response.data.per_page,
                    current_page: response.data.current_page,
                    first_page_url: new URL(response.data.first_page_url).search,
                    last_page_url: new URL(response.data.last_page_url).search,
                    next_page_url: response.data.next_page_url !== null ? new URL(response.data.next_page_url).search : null,
                    prev_page_url: response.data.prev_page_url !== null ? new URL(response.data.prev_page_url).search : null
                }
            }

            data = response.data.data
        }
        else if (response.data)
            data = response.data

        for(let item in data)
            listObjects.push(new Company(data[item]))

        this._callback(listObjects, error, pagination, status)
    }

    show(id) {
        this._rest._contentType = 'application/json';
        this._rest.sendQuery(
            'GET',
            '/' + this._baseURL + '/' + id,
            {},
            this.handleShow);
    }
    handleShow = (response, error) => {
        const object = !error ? new Company(response.data) : null;
        this._callback(object, error);
    }

    post(object) {
        const objectToSend = JSON.parse(JSON.stringify(object));
        delete objectToSend.skytill_id;

        this._rest._contentType = 'application/json';
        this._rest.sendQuery(
            'POST',
            '/' + this._baseURL,
            objectToSend,
            this.handlePost
        );
    }
    handlePost = (response, error) => {
        this._callback(response, error);
    }

    put(object, datas) {
        this._rest._contentType = 'application/json';
        this._rest.sendQuery(
            'PUT',
            '/' + this._baseURL + '/' + object.id,
			datas,
            this.handlePut
        );
    }
    handlePut = (response, error) => {
        this._callback(response, error);
    }

    delete(object) {
        this._rest._contentType = 'application/json';
        this._rest.sendQuery(
            'DELETE',
            '/' + this._baseURL + '/' + object.id,
            {},
            this.handleDelete);
    }
    handleDelete = (response, error) => {
        this._callback(response, error);
    }
}

export default CompanyController;
